// Copyright 2024-present BAIKAL AI Inc.

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=none"
// @generated from file bareun/revision_service.proto (package bareun, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Document, EncodingType, TextSpan } from "./lang_common_pb";
import { file_bareun_lang_common } from "./lang_common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bareun/revision_service.proto.
 */
export const file_bareun_revision_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bareun_lang_common]);

/**
 * 맞춤법 교정기 설정
 * 맞춤법 교정기 설정은 아무런 설정을 하지 않을 경우에 기본값을 설정하는 것을 기준으로
 * 설정한다.
 * (참고) 이 옵션은 구현 과정에서 지속적으로 추가될 수 있다.
 *
 * @generated from message bareun.RevisionConfig
 */
export type RevisionConfig = Message<"bareun.RevisionConfig"> & {
  /**
   * split sentence 비활성화하면 문장 단위 분할을 하지 않는다.
   *
   * @generated from field: bool disable_split_sentence = 1;
   */
  disableSplitSentence: boolean;

  /**
   * 복합명사 분리 사전 적용 비활성화
   *
   * @generated from field: bool disable_caret_spacing = 2;
   */
  disableCaretSpacing: boolean;

  /**
   * 보조 용언 띄어쓰기 비활성화
   *
   * @generated from field: bool disable_vx_spacing = 3;
   */
  disableVxSpacing: boolean;

  /**
   * 주어진 문장을 기사 등의 제목으로 취급, 기본값 false
   *
   * @generated from field: bool treat_as_title = 4;
   */
  treatAsTitle: boolean;

  /**
   * 제약된 구두점 사용 기능 활성화
   *
   * @generated from field: bool enable_limited_punctuation = 5;
   */
  enableLimitedPunctuation: boolean;

  /**
   * 혼동모델 비활성화 (기본값 false, true로 설정시 혼동모델 호출 안함)
   *
   * @generated from field: bool disable_confusion = 6;
   */
  disableConfusion: boolean;

  /**
   * 공백을 제거하는 것을 활성화하기
   *
   * @generated from field: bool enable_cleanup_whitespace = 11;
   */
  enableCleanupWhitespace: boolean;

  /**
   * 오타 교정 비활성화 (기본값 false, true로 설정시 오탈자 교정 안함)
   *
   * @generated from field: bool disable_typo_correction = 12;
   */
  disableTypoCorrection: boolean;

  /**
   * 문장 단위 점검 활성화
   *
   * @generated from field: bool enable_sentence_check = 21;
   */
  enableSentenceCheck: boolean;
};

/**
 * Describes the message bareun.RevisionConfig.
 * Use `create(RevisionConfigSchema)` to create a new message.
 */
export const RevisionConfigSchema: GenMessage<RevisionConfig> = /*@__PURE__*/
  messageDesc(file_bareun_revision_service, 0);

/**
 * 맞춤법 교정 요청 메시지
 *
 * @generated from message bareun.CorrectErrorRequest
 */
export type CorrectErrorRequest = Message<"bareun.CorrectErrorRequest"> & {
  /**
   * 입력 문서
   *
   * @generated from field: bareun.Document document = 1;
   */
  document?: Document | undefined;

  /**
   * 오프셋을 계산하기 위한 인코딩 타입
   *
   * @generated from field: bareun.EncodingType encoding_type = 2;
   */
  encodingType: EncodingType;

  /**
   * 커스텀 사전 도메인 정보, 하나만 지정 가능합니다.
   * v4.0에서는 폐기될 예정입니다. 새로운 custom_dict_names를 사용해주세요.
   * 새로운 custom_dict_names에 값이 들어있는 경우, 이 값은 무시됩니다.
   *
   * @generated from field: string custom_domain = 4 [deprecated = true];
   * @deprecated
   */
  customDomain: string;

  /**
   * 커스텀 사전 이름들
   * CustomDictionaryService를 사용해서 만든 사전을 여러 개 지정한다.
   * 하나 이상의 지정할 경우, 먼저 나오는 사전이 우선되어 사용된다.
   *
   * @generated from field: repeated string custom_dict_names = 5;
   */
  customDictNames: string[];

  /**
   * 맞춤법 교정기 적용시 옵션을 지정한다.
   *
   * @generated from field: bareun.RevisionConfig config = 11;
   */
  config?: RevisionConfig | undefined;
};

/**
 * Describes the message bareun.CorrectErrorRequest.
 * Use `create(CorrectErrorRequestSchema)` to create a new message.
 */
export const CorrectErrorRequestSchema: GenMessage<CorrectErrorRequest> = /*@__PURE__*/
  messageDesc(file_bareun_revision_service, 1);

/**
 * 교정에 대한 도움말 객체
 *
 * @generated from message bareun.ReviseHelp
 */
export type ReviseHelp = Message<"bareun.ReviseHelp"> & {
  /**
   * 도움말 ID, 고정된 도움말이 있을 수 있고, 동적으로 생성되는 도움말이 있을 수 있다.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 문장 교정의 카테고리
   *
   * @generated from field: bareun.RevisionCategory category = 2;
   */
  category: RevisionCategory;

  /**
   * 바뀌어야 하는 이유에 대한 섧명
   *
   * @generated from field: string comment = 3;
   */
  comment: string;

  /**
   * 변경이 될 수 있는 문장들
   *
   * @generated from field: repeated string examples = 4;
   */
  examples: string[];

  /**
   * 관련 규정
   *
   * @generated from field: string rule_article = 5;
   */
  ruleArticle: string;
};

/**
 * Describes the message bareun.ReviseHelp.
 * Use `create(ReviseHelpSchema)` to create a new message.
 */
export const ReviseHelpSchema: GenMessage<ReviseHelp> = /*@__PURE__*/
  messageDesc(file_bareun_revision_service, 2);

/**
 * 한개의 교정에 대한 정보
 *
 * @generated from message bareun.Revision
 */
export type Revision = Message<"bareun.Revision"> & {
  /**
   * 수정을 제안한 토큰
   *
   * @generated from field: string revised = 1;
   */
  revised: string;

  /**
   * 수정에 대한 점수, 점수가 높으면 수정의 후보가 높다.
   *
   * @generated from field: double score = 2;
   */
  score: number;

  /**
   * RevisionCagetory 정보
   *
   * @generated from field: bareun.RevisionCategory category = 3;
   */
  category: RevisionCategory;

  /**
   * 수정에 대한 도움말, 인덱스 정보
   *
   * @generated from field: string help_id = 4;
   */
  helpId: string;

  /**
   * 스트림 로직에서 필요한 경우 ID를 생성해서 내보낼 수 있다.
   * 생각 중인 경우에만 생성된다.
   *
   * @generated from field: optional int32 thinking_id = 100;
   */
  thinkingId?: number | undefined;
};

/**
 * Describes the message bareun.Revision.
 * Use `create(RevisionSchema)` to create a new message.
 */
export const RevisionSchema: GenMessage<Revision> = /*@__PURE__*/
  messageDesc(file_bareun_revision_service, 3);

/**
 * RevisedBlock은 교정 대상인 원문과 수정된 결과, 이유, 사용자 사전 추가 정보를 담고 있다.
 *
 * - origin: 교정의 원문으로, 교정 대상이 되는 원문의 위치와 범위 정보를 담고 있다.
 * - revised: 교정 결과를 포함하며, 여러 개의 교정 후보가 있는 경우 가장 대표적인 
 *   교정 결과를 포함한다.
 * - revisions: 하나 이상의 교정 후보를 포함하며, 각 교정 결과는 점수, 카테고리, 
 *   도움말 정보를 포함한다.
 * - nested: 여러 개의 블럭이 하나로 합쳐지는 경우, 기존의 블럭들은 nested 블럭에 
 *   포함된다.
 * - lemma: 교정 대상에 대해 교정을 하지 않을 수도 있으며, 이를 사용자 사전에 
 *   추가해야 하는 경우 원형을 밝혀 추가할 수 있도록 한다.
 * - pos: 사전에 추가할 경우, 해당 단어의 형태 정보를 포함한다.
 *
 * [여러 블럭을 합치는 경우]
 * 띄어쓰기 및 붙여쓰기가 여러 블럭에 연달아 있는 경우, 그 경계가 계속해서 
 * 합쳐질 수 있다. 예를 들어, "`하지만아무도도와드리지않았다.`"의 경우, 
 * "하지만 아무도", "아무도 도와", "도와드리지", "드리지 않았다."처럼 블럭이 
 * 서로 경계에 닿아 있다. 이 경우 "`하지만아무도도와드리지않았다.`"를 하나의 
 * 블럭으로 처리한다. 이를 UI에서 계산하여 처리하는 것은 많은 노력이 필요하므로, 
 * 위의 4가지 경우를 `nested` 블럭에 포함하여 기술하도록 한다.
 *
 * [사용자 사전 후보 제시]
 * 원문에 포함된 교정 블럭에 대한 교정 후보를 제시하는 것이 적절하지 않은 경우, 
 * 사용자는 이 단어를 새로운 사전에 등록할 수 있다. 이를 위해 등록의 원본을 
 * 제시한다. 예를 들어, "신박했다"라는 어절에 대해 교정한 경우, lemma로 "신박하"를 
 * 제시하고 "형용사"로 품사를 제시할 수 있다. 여기에는 띄어 쓴 블럭의 복합명사도 
 * 포함될 수 있다. 이 경우 "제품^품질관리^체계"처럼 대부분의 UI 처리 단위에서는 
 * 이를 세부적으로 나눠서 표현할 필요는 없지만, 포함된 블럭을 구분하여 표현하고자 
 * 하는 경우에도 이를 감안할 수 있다.
 *
 * @generated from message bareun.RevisedBlock
 */
export type RevisedBlock = Message<"bareun.RevisedBlock"> & {
  /**
   * 교정 원문의 위치 및 원문 정보
   * 대부분은 어절 단위이지만, nested가 있는 경우 여러 블럭이 포함될 수 있다.
   * 원문의 한 어절에 여러 개의 교정이 있는 경우에는 이를 묶을 수도 있다.
   *
   * @generated from field: bareun.TextSpan origin = 1;
   */
  origin?: TextSpan | undefined;

  /**
   * 교정된 결과물, 여러가지 중에 하나로서 가장 대표적인 것
   *
   * @generated from field: string revised = 2;
   */
  revised: string;

  /**
   * 다양한 교정 문장의 예시들
   *
   * @generated from field: repeated bareun.Revision revisions = 3;
   */
  revisions: Revision[];

  /**
   * 한 어절에 여러 개의 수정이 이뤄지거나,
   * 서로 다른 어절의 수정이 경계를 닿아서 겹치는 경우에는
   * 기존의 교정 블럭은 nested에 포함된다.
   *
   * @generated from field: repeated bareun.RevisedBlock nested = 10;
   */
  nested: RevisedBlock[];

  /**
   * 사용사 사전에 추가하기 위한 기본 단위, nested가 존재하는 쓸 수 없다.
   *
   * @generated from field: string lemma = 4;
   */
  lemma: string;

  /**
   * 사용사 사전에 추가할 품사
   *
   * @generated from field: bareun.CustomDictPos pos = 5;
   */
  pos: CustomDictPos;

  /**
   * 현재 블럭에 생각중인 경우가 하나 이상 있으면 표시해준다.
   *
   * @generated from field: optional int32 thinking_count = 100;
   */
  thinkingCount?: number | undefined;
};

/**
 * Describes the message bareun.RevisedBlock.
 * Use `create(RevisedBlockSchema)` to create a new message.
 */
export const RevisedBlockSchema: GenMessage<RevisedBlock> = /*@__PURE__*/
  messageDesc(file_bareun_revision_service, 4);

/**
 * 교정된 하나의 문장
 *
 * @generated from message bareun.RevisedSentence
 */
export type RevisedSentence = Message<"bareun.RevisedSentence"> & {
  /**
   * 원래 문장
   *
   * @generated from field: string origin = 1;
   */
  origin: string;

  /**
   * 교정된 전체 문장
   *
   * @generated from field: string revised = 2;
   */
  revised: string;
};

/**
 * Describes the message bareun.RevisedSentence.
 * Use `create(RevisedSentenceSchema)` to create a new message.
 */
export const RevisedSentenceSchema: GenMessage<RevisedSentence> = /*@__PURE__*/
  messageDesc(file_bareun_revision_service, 5);

/**
 * CleanUpRange 교정대상에서 불필요한 공백을 지워야할 범위
 *
 * @generated from message bareun.CleanUpRange
 */
export type CleanUpRange = Message<"bareun.CleanUpRange"> & {
  /**
   * 위치
   *
   * @generated from field: int32 offset = 1;
   */
  offset: number;

  /**
   * 길이
   *
   * @generated from field: int32 length = 2;
   */
  length: number;

  /**
   * @generated from field: bareun.CleanUpRange.CleanUpPosition position = 3;
   */
  position: CleanUpRange_CleanUpPosition;
};

/**
 * Describes the message bareun.CleanUpRange.
 * Use `create(CleanUpRangeSchema)` to create a new message.
 */
export const CleanUpRangeSchema: GenMessage<CleanUpRange> = /*@__PURE__*/
  messageDesc(file_bareun_revision_service, 6);

/**
 * 지워야할 위치에 대한 추가 정보
 *
 * @generated from enum bareun.CleanUpRange.CleanUpPosition
 */
export enum CleanUpRange_CleanUpPosition {
  /**
   * 처음
   *
   * @generated from enum value: START = 0;
   */
  START = 0,

  /**
   * 끝
   *
   * @generated from enum value: END = 1;
   */
  END = 1,

  /**
   * 중간
   *
   * @generated from enum value: MIDDLE = 2;
   */
  MIDDLE = 2,
}

/**
 * Describes the enum bareun.CleanUpRange.CleanUpPosition.
 */
export const CleanUpRange_CleanUpPositionSchema: GenEnum<CleanUpRange_CleanUpPosition> = /*@__PURE__*/
  enumDesc(file_bareun_revision_service, 6, 0);

/**
 * 맞춤법 교정의 응답
 *
 * @generated from message bareun.CorrectErrorResponse
 */
export type CorrectErrorResponse = Message<"bareun.CorrectErrorResponse"> & {
  /**
   * 원래 요청 문서
   *
   * @generated from field: string origin = 1;
   */
  origin: string;

  /**
   * 교정 문장 문서
   *
   * @generated from field: string revised = 2;
   */
  revised: string;

  /**
   * 수정된 결과들 하나 이상
   *
   * @generated from field: repeated bareun.RevisedBlock revised_blocks = 3;
   */
  revisedBlocks: RevisedBlock[];

  /**
   * 교정대상에서 지워야할 공백들의 목록
   *
   * @generated from field: repeated bareun.CleanUpRange whitespace_cleanup_ranges = 9;
   */
  whitespaceCleanupRanges: CleanUpRange[];

  /**
   * 교정된 문장들
   *
   * @generated from field: repeated bareun.RevisedSentence revised_sentences = 11;
   */
  revisedSentences: RevisedSentence[];

  /**
   * 교정 도움말들에 대한 정보
   *
   * @generated from field: map<string, bareun.ReviseHelp> helps = 12;
   */
  helps: { [key: string]: ReviseHelp };

  /**
   * 텍스트의 언어, 만일 언어가 지정되지 않은 경우에는 자동으로 탐지하여 반환한다.
   * 언어가 지정된 경우에는 동일한 언어를 반환한다.
   * 이때, 언어는 ko_KR 등과 같이 사용한다.
   *
   * @generated from field: string language = 99;
   */
  language: string;

  /**
   * 어절의 개수
   *
   * @generated from field: int32 tokens_count = 100;
   */
  tokensCount: number;
};

/**
 * Describes the message bareun.CorrectErrorResponse.
 * Use `create(CorrectErrorResponseSchema)` to create a new message.
 */
export const CorrectErrorResponseSchema: GenMessage<CorrectErrorResponse> = /*@__PURE__*/
  messageDesc(file_bareun_revision_service, 7);

/**
 * 맞춤법 교정 요청 메시지
 *
 * @generated from message bareun.StreamCorrectErrorRequest
 */
export type StreamCorrectErrorRequest = Message<"bareun.StreamCorrectErrorRequest"> & {
  /**
   * 입력 문서
   *
   * @generated from field: bareun.Document document = 1;
   */
  document?: Document | undefined;

  /**
   * 오프셋을 계산하기 위한 인코딩 타입
   *
   * @generated from field: bareun.EncodingType encoding_type = 2;
   */
  encodingType: EncodingType;

  /**
   * 커스텀 사전 도메인 정보, 하나만 지정 가능합니다.
   * v4.0에서는 폐기될 예정입니다. 새로운 custom_dict_names를 사용해주세요.
   * 새로운 custom_dict_names에 값이 들어있는 경우, 이 값은 무시됩니다.
   *
   * @generated from field: string custom_domain = 4 [deprecated = true];
   * @deprecated
   */
  customDomain: string;

  /**
   * 커스텀 사전 이름들
   * CustomDictionaryService를 사용해서 만든 사전을 여러 개 지정한다.
   * 하나 이상의 지정할 경우, 먼저 나오는 사전이 우선되어 사용된다.
   *
   * @generated from field: repeated string custom_dict_names = 5;
   */
  customDictNames: string[];

  /**
   * 맞춤법 교정기 적용시 옵션을 지정한다.
   *
   * @generated from field: bareun.RevisionConfig config = 11;
   */
  config?: RevisionConfig | undefined;

  /**
   * 동시에 여러 요청이 발생할 수 있으므로 이 요청에 대해서 ID를 부여한다.
   * 요청 ID가 비어 있으면 서버에서 생성한다.
   * 즉 이 요청 ID를 빈 상태로 보내줘도 된다.
   *
   * @generated from field: int64 req_id = 101;
   */
  reqId: bigint;
};

/**
 * Describes the message bareun.StreamCorrectErrorRequest.
 * Use `create(StreamCorrectErrorRequestSchema)` to create a new message.
 */
export const StreamCorrectErrorRequestSchema: GenMessage<StreamCorrectErrorRequest> = /*@__PURE__*/
  messageDesc(file_bareun_revision_service, 8);

/**
 * 첫번째 기본 응답
 *
 * @generated from message bareun.StreamFirstCorrectError
 */
export type StreamFirstCorrectError = Message<"bareun.StreamFirstCorrectError"> & {
  /**
   * 원래 요청 문서
   *
   * @generated from field: string origin = 1;
   */
  origin: string;

  /**
   * 교정 문장 문서
   *
   * @generated from field: string revised = 2;
   */
  revised: string;

  /**
   * 수정된 결과들 하나 이상
   *
   * @generated from field: repeated bareun.RevisedBlock revised_blocks = 3;
   */
  revisedBlocks: RevisedBlock[];

  /**
   * 교정대상에서 지워야할 공백들의 목록
   *
   * @generated from field: repeated bareun.CleanUpRange whitespace_cleanup_ranges = 9;
   */
  whitespaceCleanupRanges: CleanUpRange[];

  /**
   * 교정된 문장들
   *
   * @generated from field: repeated bareun.RevisedSentence revised_sentences = 11;
   */
  revisedSentences: RevisedSentence[];

  /**
   * 교정 도움말들에 대한 정보
   *
   * @generated from field: map<string, bareun.ReviseHelp> helps = 12;
   */
  helps: { [key: string]: ReviseHelp };

  /**
   * 텍스트의 언어, 만일 언어가 지정되지 않은 경우에는 자동으로 탐지하여 반환한다.
   * 언어가 지정된 경우에는 동일한 언어를 반환한다.
   * 이때, 언어는 ko_KR 등과 같이 사용한다.
   *
   * @generated from field: string language = 99;
   */
  language: string;

  /**
   * 어절의 개수
   *
   * @generated from field: int32 tokens_count = 100;
   */
  tokensCount: number;

  /**
   * 요청의 ID
   * 추가적인 생각 중이 있는 경우에는 이 요청에 대한 ID를 생성한다.
   * 스트리밍 방식의 요청일 때에만 사용한다.
   *
   * @generated from field: int64 req_id = 201;
   */
  reqId: bigint;

  /**
   * thinking id들의 배열
   *
   * @generated from field: repeated int32 thinking_ids = 101;
   */
  thinkingIds: number[];
};

/**
 * Describes the message bareun.StreamFirstCorrectError.
 * Use `create(StreamFirstCorrectErrorSchema)` to create a new message.
 */
export const StreamFirstCorrectErrorSchema: GenMessage<StreamFirstCorrectError> = /*@__PURE__*/
  messageDesc(file_bareun_revision_service, 9);

/**
 * 이전의 수정 중에서 취소가 된 경우 메시지
 *
 * @generated from message bareun.CancelledRevision
 */
export type CancelledRevision = Message<"bareun.CancelledRevision"> & {
  /**
   * 취소할 요청의 ID
   *
   * @generated from field: int64 req_id = 1;
   */
  reqId: bigint;

  /**
   * 취소할 thinking Revision
   * 클라이언트는 해당 revision을 삭제해야 한다.
   * 원칙은 원문을 그대로 내보내는 게 맞다.
   *
   * @generated from field: int32 thinking_id = 2;
   */
  thinkingId: number;
};

/**
 * Describes the message bareun.CancelledRevision.
 * Use `create(CancelledRevisionSchema)` to create a new message.
 */
export const CancelledRevisionSchema: GenMessage<CancelledRevision> = /*@__PURE__*/
  messageDesc(file_bareun_revision_service, 10);

/**
 * 후교정된 블럭 정보
 *
 * @generated from message bareun.PostRevision
 */
export type PostRevision = Message<"bareun.PostRevision"> & {
  /**
   * 먼저 전송된 요청의 ID
   *
   * @generated from field: int64 req_id = 1;
   */
  reqId: bigint;

  /**
   * 먼저 전송된 thinking id
   *
   * @generated from field: int32 thinking_id = 2;
   */
  thinkingId: number;

  /**
   * 최종 수정된 결과
   *
   * @generated from field: bareun.Revision revision = 3;
   */
  revision?: Revision | undefined;

  /**
   * 최종 수정 도움말
   *
   * @generated from field: bareun.ReviseHelp help = 4;
   */
  help?: ReviseHelp | undefined;
};

/**
 * Describes the message bareun.PostRevision.
 * Use `create(PostRevisionSchema)` to create a new message.
 */
export const PostRevisionSchema: GenMessage<PostRevision> = /*@__PURE__*/
  messageDesc(file_bareun_revision_service, 11);

/**
 * 취소나 확정 전에 AI 진행 상태를 나타낸다.
 *
 * @generated from message bareun.ProgressRevision
 */
export type ProgressRevision = Message<"bareun.ProgressRevision"> & {
  /**
   * 먼저 전송된 req_id
   *
   * @generated from field: int64 req_id = 1;
   */
  reqId: bigint;

  /**
   * 먼저 전송된 thinking id
   *
   * @generated from field: int32 thinking_id = 2;
   */
  thinkingId: number;

  /**
   * 생각 중임을 나타내는 메시지
   *
   * @generated from field: string thinking_msg = 3;
   */
  thinkingMsg: string;
};

/**
 * Describes the message bareun.ProgressRevision.
 * Use `create(ProgressRevisionSchema)` to create a new message.
 */
export const ProgressRevisionSchema: GenMessage<ProgressRevision> = /*@__PURE__*/
  messageDesc(file_bareun_revision_service, 12);

/**
 * 스트림 방식의 교정 결과를 내보낸다.
 *
 * @generated from message bareun.StreamCorrectErrorResponse
 */
export type StreamCorrectErrorResponse = Message<"bareun.StreamCorrectErrorResponse"> & {
  /**
   * 응답 메시지는 크게 4가지이다.
   *
   * @generated from oneof bareun.StreamCorrectErrorResponse.res
   */
  res: {
    /**
     * 첫번째 교정 결과 응답
     *
     * @generated from field: bareun.StreamFirstCorrectError first = 1;
     */
    value: StreamFirstCorrectError;
    case: "first";
  } | {
    /**
     * 취소된 교정 결과 응답
     *
     * @generated from field: bareun.CancelledRevision cancelled = 2;
     */
    value: CancelledRevision;
    case: "cancelled";
  } | {
    /**
     * 확정된 교정 결과 응답
     *
     * @generated from field: bareun.PostRevision post = 3;
     */
    value: PostRevision;
    case: "post";
  } | {
    /**
     * 각 Thinking revision 단위로 생각 중 메시지를 전송
     *
     * @generated from field: bareun.ProgressRevision progress = 4;
     */
    value: ProgressRevision;
    case: "progress";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message bareun.StreamCorrectErrorResponse.
 * Use `create(StreamCorrectErrorResponseSchema)` to create a new message.
 */
export const StreamCorrectErrorResponseSchema: GenMessage<StreamCorrectErrorResponse> = /*@__PURE__*/
  messageDesc(file_bareun_revision_service, 13);

/**
 * 한국어 문장 교정의 카테고리
 *
 * @generated from enum bareun.RevisionCategory
 */
export enum RevisionCategory {
  /**
   * 교정 카테고리가 없음
   *
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * 교정 유형: 맞춤법 어법에 관한 사항
   * 활용, 조사 결합, 구둣점 등
   *
   * @generated from enum value: GRAMMER = 1;
   */
  GRAMMER = 1,

  /**
   * 교정 유형: 맞춤법 단어단위 규칙에 관한 사항
   * 사이시옷, 두음법칙, 한자결합(율,률) 등
   *
   * @generated from enum value: WORD = 2;
   */
  WORD = 2,

  /**
   * 교정 유형: 띄어쓰기에 관한 사항
   *
   * @generated from enum value: SPACING = 3;
   */
  SPACING = 3,

  /**
   * 교정 유형: 표준어 일반
   *
   * @generated from enum value: STANDARD = 8;
   */
  STANDARD = 8,

  /**
   * 교정 유형: 오탈자
   *
   * @generated from enum value: TYPO = 9;
   */
  TYPO = 9,

  /**
   * 교정 유형: 외래어 표기법
   *
   * @generated from enum value: FOREIGN_WORD = 10;
   */
  FOREIGN_WORD = 10,

  /**
   * 교정 유형: 혼동하기 쉬운 단어
   *
   * @generated from enum value: CONFUSABLE_WORDS = 11;
   */
  CONFUSABLE_WORDS = 11,

  /**
   * 교정 유형: 문장 단위 오류
   *
   * @generated from enum value: SENTENCE = 12;
   */
  SENTENCE = 12,

  /**
   * 교정 유형: 확인 필요
   *
   * @generated from enum value: CONFIRM = 13;
   */
  CONFIRM = 13,

  /**
   * 생각 중: 복잡한 후처리 작업이 필요한 경우
   * 먼저 원문을 그대로 내보내는 게 맞다.
   * 화면 상에서는 다른 색깔이나 텍스트 효과를 나타낸다.
   *
   * @generated from enum value: THINKING = 14;
   */
  THINKING = 14,
}

/**
 * Describes the enum bareun.RevisionCategory.
 */
export const RevisionCategorySchema: GenEnum<RevisionCategory> = /*@__PURE__*/
  enumDesc(file_bareun_revision_service, 0);

/**
 * 사용자 사전용 형태소
 *
 * @generated from enum bareun.CustomDictPos
 */
export enum CustomDictPos {
  /**
   * 해당 없음
   *
   * @generated from enum value: POS_UNK = 0;
   */
  POS_UNK = 0,

  /**
   * 복합명사 사전
   *
   * @generated from enum value: POS_NNG = 1;
   */
  POS_NNG = 1,

  /**
   * 고유명사 사전
   *
   * @generated from enum value: POS_NNP = 2;
   */
  POS_NNP = 2,

  /**
   * 복합명사 분리 사전
   *
   * @generated from enum value: POS_NNG_CARET = 3;
   */
  POS_NNG_CARET = 3,

  /**
   * 동사 사전
   *
   * @generated from enum value: POS_VV = 4;
   */
  POS_VV = 4,

  /**
   * 형용사 사전
   *
   * @generated from enum value: POS_VA = 5;
   */
  POS_VA = 5,

  /**
   * 관형사 사전
   *
   * @generated from enum value: POS_MM = 6;
   */
  POS_MM = 6,

  /**
   * 부사 사전
   *
   * @generated from enum value: POS_MAG = 7;
   */
  POS_MAG = 7,

  /**
   * 감탄사 사전
   *
   * @generated from enum value: POS_IC = 8;
   */
  POS_IC = 8,
}

/**
 * Describes the enum bareun.CustomDictPos.
 */
export const CustomDictPosSchema: GenEnum<CustomDictPos> = /*@__PURE__*/
  enumDesc(file_bareun_revision_service, 1);

/**
 * 다양한 목적에 맞는 문장 교정 서비스
 * 이 서비스는 다른 과금 체계를 가지므로 다양하게 재구성한다.
 *
 * @generated from service bareun.RevisionService
 */
export const RevisionService: GenService<{
  /**
   * 맞춤법 교정을 수행한다.
   *
   * @generated from rpc bareun.RevisionService.CorrectError
   */
  correctError: {
    methodKind: "unary";
    input: typeof CorrectErrorRequestSchema;
    output: typeof CorrectErrorResponseSchema;
  },
  /**
   * 맞춤법 교정을 실시간으로 진행한다.
   * 웹을 고려했을 때, 하나의 grpc 또는 connect rpc를 해보면
   *
   *
   * @generated from rpc bareun.RevisionService.StreamCorrectError
   */
  streamCorrectError: {
    methodKind: "server_streaming";
    input: typeof StreamCorrectErrorRequestSchema;
    output: typeof StreamCorrectErrorResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bareun_revision_service, 0);

